













































import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'
// import Autocomplete from 'vue2-autocomplete-js'
export default Vue.extend({
    components: {
        // Autocomplete
    },
    computed: {
        ...mapState('mapplantsMappa', ['statoRilevamenti']),

        idRilevamento: {
            get(): number {
                return this.$store.state.mapplantsFiltriCensimento.idRilevamento
            },
            set(value: number) {
                this.SET_ID_RILEVAMENTO(value)
            }
        },
        idTag: {
            get(): number {
                return this.$store.state.mapplantsFiltriCensimento.idTag
            },
            set(value: number) {
                this.SET_ID_TAG(value)
            }
        },
        giudizioRadiciColletto: {
            get(): number {
                return this.$store.state.mapplantsFiltriCensimento.giudizioRadiciColletto
            },
            set(value: number) {
                this.SET_GIUDIZIO_RADICI_COLLETTO(value)
            }
        },
        giudizioFustoBranche: {
            get(): number {
                return this.$store.state.mapplantsFiltriCensimento.giudizioFustoBranche
            },
            set(value: number) {
                this.SET_GIUDIZIO_FUSTO_BRANCHE(value)
            }
        },
        giudizioRamiChioma: {
            get(): number {
                return this.$store.state.mapplantsFiltriCensimento.giudizioRamiChioma
            },
            set(value: number) {
                this.SET_GIUDIZIO_RAMI_CHIOMA(value)
            }
        },
        contesto: {
            get(): any {
                return this.$store.state.mapplantsFiltriCensimento.contesto
            },
            set(value: any) {
                this.SET_CONTESTO(value)
            }
        },

        dataUltimoRilevamentoParsata(): string {
            // leggiamo la data
            moment.locale('it')
            return moment(this.statoRilevamenti.data_ultimo_rilevamento).format('DD MMMM YYYY')
        }
    },
    methods: {
        ...mapMutations('mapplantsFiltriCensimento', ['SET_ID_TAG', 'SET_ID_RILEVAMENTO', 'SET_GIUDIZIO_RADICI_COLLETTO',
            'SET_GIUDIZIO_FUSTO_BRANCHE', 'SET_GIUDIZIO_RAMI_CHIOMA', 'SET_CONTESTO']),
        resettaFiltri() {
            this.idRilevamento = null
            this.idTag = null
            this.giudizioRadiciColletto = -1
            this.giudizioFustoBranche = -1
            this.giudizioRamiChioma = -1
            this.contesto = -1
            this.interventiFitosanitari = []
        }
    }
})
